import React, { useState } from 'react'
import { Box, Typography, useMediaQuery, ButtonBase, Menu, MenuItem } from '@mui/material'
import logoutIcon from '@meprism/shared/src/assets/icons/logout.svg'
import { CorporateProfileSelector } from '../../../redux/CorporateProfile/CorporateProfileSlice'
import { theme } from '../../../config/Dashboardtheme'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../../redux/storeExports'
import { logOutUser } from '@meprism/shared/src/redux/authentication/authenticationSlice'
import nexticon from '@meprism/shared/src/assets/icons/next.svg'

interface titleprops {
  title: string
  count?:number
}
const MainHeader = (props: titleprops) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const corporateProfile = CorporateProfileSelector()
  const name = corporateProfile?.companyName
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchor(event.currentTarget);
  };
  const navigate = useNavigate()
const dispatch=useAppDispatch()
  const handleMenuClose = () => {
    setMenuAnchor(null);
  };
  const handleLogout = async () => {
    await dispatch(logOutUser()).unwrap()
    navigate('/login')
  }
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        padding: '10px 0',
        gap: '120px',
        height: '54px',
        flex: 'none',
        order: 0,
        alignSelf: 'stretch',
        flexGrow: 0,
        mt: isMobile ? 10 : 0,
    }}>
      <Typography variant="h2">{props.title}
      {props.count !== undefined && props.count>0 &&(<span style={{marginLeft:5}}>{'('+(props.count)+')'}</span>)}</Typography>
      {!isMobile && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 0,
            gap: '30px',
            isolation: 'isolate',
            width: '183px',
            height: '24px',
            flex: 'none',
            order: 1,
            flexGrow: 0,
          }}
        >
          <ButtonBase
            onClick={handleMenuOpen}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              height: '18px',
              opacity: 1,
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: 1,
              }}
            >
              <img src={logoutIcon} alt="icon" style={{ width: '100%', height: '100%' }} />
            </Box>
            <Typography
              sx={{
                fontWeight: 500,
                fontStyle: 'Medium',
                fontSize: '14px',
                lineHeight: '14px',
                letterSpacing: 0,
                textAlign: 'center',
                verticalAlign: 'middle',
                height: '14px',
                whiteSpace: 'nowrap',
              }}
            >
              Hello, {name}
            </Typography>

            <Box
              sx={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transform: 'rotate(90deg)',
                opacity: 1,
              }}
            >
              <img src={nexticon} alt="next-icon"/>
            </Box>
          </ButtonBase>

          {/* Profile Menu */}
          <Menu
            id="profile-menu"
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={handleMenuClose}
            sx={{ borderRadius: '20px' }}
          >
            <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
          </Menu>
        </Box>
      )}
    </Box>
  )
}
export default MainHeader
